/* Retro Shores – show only the selected size's photos on product pages.
   Photos are matched by their alt text ending in "Size Small" or "Size Large"
   (set in Shopify admin → product → click photo → Alt text). Photos without
   a size in their alt text show for every size. */
(function () {
  var style = document.createElement('style');
  style.textContent =
    'html[data-rs-size="large"] .product__media-item:has(img[alt$="Size Small"]),' +
    'html[data-rs-size="large"] .thumbnail-list__item:has(img[alt$="Size Small"]),' +
    'html[data-rs-size="small"] .product__media-item:has(img[alt$="Size Large"]),' +
    'html[data-rs-size="small"] .thumbnail-list__item:has(img[alt$="Size Large"])' +
    '{ display: none !important; }';
  document.head.appendChild(style);

  function sizeFrom(text) {
    text = text || '';
    if (/large/i.test(text)) return 'large';
    if (/small/i.test(text)) return 'small';
    return '';
  }

  function currentSize() {
    var el = document.querySelector(
      'variant-selects input[type="radio"]:checked, variant-selects select option:checked'
    );
    return el ? sizeFrom(el.value || el.textContent) : '';
  }

  function apply(size) {
    size = size || currentSize();
    if (size) {
      document.documentElement.setAttribute('data-rs-size', size);
    } else {
      document.documentElement.removeAttribute('data-rs-size');
    }
    document.querySelectorAll('media-gallery slider-component').forEach(function (s) {
      try {
        if (typeof s.resetPages === 'function') s.resetPages();
        var shown = s.sliderItemsToShow ? s.sliderItemsToShow.length : 2;
        var buttons = s.querySelector('.slider-buttons');
        if (buttons) buttons.style.display = shown < 2 ? 'none' : '';
        if (shown >= 2 && s.slider && typeof s.update === 'function') {
          s.slider.scrollTo({ left: 0 });
          s.update();
        }
      } catch (e) {}
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    apply();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        apply(sizeFrom(variant ? variant.title : ''));
        setTimeout(function () { apply(); }, 300);
      });
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) {
      apply();
      setTimeout(function () { apply(); }, 400);
    }
  });
})();
